module.exports = __webpack_public_path__ + "static/media/DamLogo.7407cb3b.svg";